/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoCampaignRemoveRequest model module.
 * @module model/CampaignControllerDtoCampaignRemoveRequest
 * @version 1.0
 */
class CampaignControllerDtoCampaignRemoveRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoCampaignRemoveRequest</code>.
     * @alias module:model/CampaignControllerDtoCampaignRemoveRequest
     * @param campaignNo {Array.<Number>} 
     */
    constructor(campaignNo) { 
        
        CampaignControllerDtoCampaignRemoveRequest.initialize(this, campaignNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, campaignNo) { 
        obj['campaignNo'] = campaignNo;
    }

    /**
     * Constructs a <code>CampaignControllerDtoCampaignRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCampaignRemoveRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCampaignRemoveRequest} The populated <code>CampaignControllerDtoCampaignRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCampaignRemoveRequest();

            if (data.hasOwnProperty('campaignNo')) {
                obj['campaignNo'] = ApiClient.convertToType(data['campaignNo'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCampaignRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCampaignRemoveRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoCampaignRemoveRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is an array
        if (!Array.isArray(data['campaignNo'])) {
            throw new Error("Expected the field `campaignNo` to be an array in the JSON data but got " + data['campaignNo']);
        }

        return true;
    }


}

CampaignControllerDtoCampaignRemoveRequest.RequiredProperties = ["campaignNo"];

/**
 * @member {Array.<Number>} campaignNo
 */
CampaignControllerDtoCampaignRemoveRequest.prototype['campaignNo'] = undefined;






export default CampaignControllerDtoCampaignRemoveRequest;

